import { CLEAR_MODAL_PROFILE, SET_MODAL_PROFILE } from 'store/types/profile';

export const setModalProfile = (modal) => {
  return {
    type: SET_MODAL_PROFILE,
    payload: modal,
  };
};

export const clearModalProfile = () => {
  return {
    type: CLEAR_MODAL_PROFILE,
    payload: null,
  };
};
